module.exports = __webpack_public_path__ + "img/tron (66).e1ee843c.jpg";